import React, { FC } from 'react';
import classNames from 'classnames';
import styles from './PastPerformanceStatement.module.scss';

type Props = {
  className?: string;
  children?: React.ReactNode;
};

const PastPerformanceStatement: FC<Props> = ({ className, children }) => (
  <div className={classNames(styles['legal-disclaimer'], className)}>
    Past performance is not a reliable indicator of future performance.
    {children}
  </div>
);

export default PastPerformanceStatement;
